export const ONE_WAY = 'oneway'
export const RETURN = 'return'

export const SWIPER_NEXT_EL_ID = 'influencer-slider-next-btn'
export const SWIPER_PREV_EL_ID = 'influencer-slider-prev-btn'

export const SORT_DEFAULT = 'default'
export const SORT_ASC = 'asc'
export const SORT_DESC = 'desc'
export const SORT_ASC_PRICE = 'asc-price'
export const SORT_DESC_PRICE = 'desc-price'
export const SORT_ASC_COUNTRY = 'asc-country'
export const SORT_DESC_COUNTRY = 'desc-country'

export const SORT_OPTION_LIST = [
  {
    id: SORT_ASC,
    label: 'clp.sorterBlock.cityAsc'
  },
  {
    id: SORT_DESC,
    label: 'clp.sorterBlock.cityDesc'
  },
  {
    id: SORT_ASC_PRICE,
    label: 'clp.sorterBlock.priceAsc'
  },
  {
    id: SORT_ASC_COUNTRY,
    label: 'clp.sorterBlock.countryAsc'
  },
  {
    id: SORT_DESC_COUNTRY,
    label: 'clp.sorterBlock.countryDesc'
  },
  {
    id: SORT_DEFAULT,
    label: 'clp.sorterBlock.default'
  }
]
